import React from 'react';
import classNames from 'classnames';
import EmptyState from 'assets/images/reports-empty-state.webp';
import { useTranslation } from 'react-i18next';
import ResolveImage from 'components/ResolveImage';
import { SIZE, Size } from 'models/Size';

import './ReportsEmptyState.styles.scss';

type ReportsEmptyStateProps = {
  className?: string;
  size?: Size;
};

const ReportsEmptyState: React.FC<ReportsEmptyStateProps> = (props) => {
  const { className, size = SIZE.SMALL } = props;

  const { t } = useTranslation();

  const classes = classNames('reports-empty-state', size, className);

  return (
    <div className={classes}>
      <ResolveImage
        src={EmptyState}
        asIllustration
        alt="Nothing to see here yet."
      />
      <p>{t('nothingToSeeHereYet')}</p>
    </div>
  );
};

export default ReportsEmptyState;
